module.exports = __webpack_public_path__ + "static/media/battleship.0c6017bb.svg";